import { supabase } from "@/integrations/supabase/client";
import { isBelowMinimum } from "@/lib/clientVersion/compareVersions";

// Rappel de mise à jour des apps natives : la version minimale par plateforme
// vit dans la table app_min_versions. Règle d'or : jamais de rappel à tort.
// Réseau coupé, table absente, valeur illisible : rien ne s'affiche.

export const STORE_URLS: Record<"ios" | "android", string> = {
  ios: "https://apps.apple.com/app/id6760735503",
  android: "https://play.google.com/store/apps/details?id=com.flowcutai.app",
};

/** Délai minimal entre deux lectures du minimum (retours au premier plan). */
export const MIN_VERSION_CHECK_INTERVAL_MS = 300_000;

export async function fetchMinVersion(platform: "ios" | "android"): Promise<string | null> {
  try {
    const { data, error } = await supabase
      .from("app_min_versions")
      .select("min_version")
      .eq("platform", platform)
      .maybeSingle();
    if (error || !data) return null;
    return data.min_version;
  } catch {
    return null;
  }
}

export async function isNativeUpdateRequired(deps: {
  getCurrentVersion: () => Promise<string | null>;
  fetchMin: () => Promise<string | null>;
}): Promise<boolean> {
  try {
    const [current, minimum] = await Promise.all([deps.getCurrentVersion(), deps.fetchMin()]);
    return isBelowMinimum(current, minimum);
  } catch {
    return false;
  }
}
